import React, { Component } from 'react'
import { Card, Row, Col, CardBody, Collapse,Button } from 'reactstrap'
import {
  InfoBlockA,
  InfoBlockB,
  InfoBlockC,
  InfoBlock,
  ActionButton,
  DeleteButton,
  ActionBlock,
  AssignBlock,
  AssignButton
} from './'
import ActionButtonSecondary from './ActionButtonSecondary'
import DeleteButtonSecondary from './DeleteButtonSecondary'
import queryString from 'query-string'


export default class InfoCard extends Component {

  state = {
    screen : false
  }

  componentDidMount(){
    this.calcWidth();
    window.addEventListener('resize', ()=>{
      this.calcWidth()
    })  
}

calcWidth = () => {
  let widthClient = document.documentElement.clientWidth;
      if(widthClient < 768){
        this.setState({screen : true})
      }
      else{
        this.setState({screen:false})
      }
}

  render(){
    let {record,
      recordType,
      actionId,
      history,
      search,
      user,
      students } = this.props

      const qs = queryString.parse(search)
      let {screen} = this.state


let {pathname} = history.location 
let DAd = pathname.includes('/users/manage/district-admins')
let UserS = pathname.includes('/users/manage/schools')
let SAd = pathname.includes('users/manage/school-admins/')
let UserT = pathname.includes('/users/manage/teachers')
let UserC = pathname.includes('/users/manage/classes/')
let UserSt = pathname.includes('/users/manage/students')


    return (
<li className='info-card'>
      <Card>
        <CardBody>

        <Row noGutters>

          {/* The Validated Registration Icon */}
          {/* {record.role && <RegIndicator registered={record.validated} />} */}

          {/* The Info Block (all User info) */}
          <Col md={recordType === 'class' ? '7' : '10'} lg={(recordType === 'class') && '8'} xl={(recordType === 'class') && '9'} >
          {(DAd || SAd || UserT || UserSt) && <InfoBlockA record={record} recordType={recordType} />}
          {UserS && <InfoBlockB record={record} recordType={recordType} />}
         {UserC && <InfoBlockC record={record} recordType={recordType} />}
          </Col>
          <Col className='action-buttons' xs='12' md={recordType === 'class' ? '5' : '2'} lg={(recordType === 'class') && '4'} xl={(recordType === 'class') && '3'} >


          {/* The Edit Button */}
         {!screen && <React.Fragment><ActionButton id={record.id} actionId={actionId} history={history} search={search} />


          <DeleteButton id={record.id} history={history} search={search} /></React.Fragment>}

           {/* Button for Assigning Students to Classes */}
           {recordType === 'class' && !screen && <AssignButton id={record.id} actionId={actionId} history={history} search={search} />}
          </Col>





          {/* Renders the block for editing a district/school/user/etc. */}
          {actionId === record.id && (qs.m !== 'delete' && qs.m !== 'assign') &&
            <ActionBlock record={record} history={history} user={user} recordType={recordType} />
          }

          {/* Block for Assigning Students to a Class */}
          {actionId === record.id && qs.m === 'assign' &&
            <AssignBlock
              record={record}
              history={history}
              user={user}
              recordType={recordType}
              students={students}
            />
          }


        </Row>
        </CardBody>
        {screen && <Row style={{"textAlign":"center" , "padding":"0 15px"}}>
          <Col xs={recordType === 'class' ? '4' : '6'} style={{"textAlign":"center" , "padding":"0 0"}}>
          <ActionButtonSecondary id={record.id} actionId={actionId} history={history} search={search} />
          </Col>
          <Col xs={recordType === 'class' ? '4' : '6'} style={{"textAlign":"center" , "padding":"0 0" }}>
          <DeleteButtonSecondary id={record.id} history={history} styles={{"width": "100%", "height":"30px","borderRadius": recordType !== 'class' &&   "0 0 6px 0"  , "backgroundColor":"#ff7d7d"}} search={search}  />
          </Col>
          {recordType === 'class'
            && <Col xs={recordType === 'class' ? '4' : '6'} style={{"textAlign":"center" , "padding":"0 0"}}> 
            <AssignButton id={record.id} propsClass={{"width": "100%", "height":"30px","borderRadius":"0 0 6px 0", "backgroundColor":"#334c59"}} actionId={actionId} history={history} search={search} />
            </Col>
          }
          </Row>
          
        }
      </Card>
    </li>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoCard.js